var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{ref:"aside",staticClass:"sidebar collapsed",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"aside-holder"},[_c('SideBarTop'),_c('SideBarPreloader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }